import React from 'react';

import {
  IInfoBlockItemProps,
  IInfoBlockItemsProps,
  IInfoBlockProps,
  IInfoBlockTitleProps,
  IInfoBlockValueProps,
} from './InfoBlock.types';

import './InfoBlock.styles.scss';

const InfoBlock = ({ children, className = '', ...props }: IInfoBlockProps) => (
  <div className={`np-info-block ${className}`} {...props}>
    {children}
  </div>
);

InfoBlock.Items = ({ children, noBottomLine, ...props }: IInfoBlockItemsProps) => (
  <div className={`np-info-block__items ${noBottomLine ? 'np-info-block__items--no-border' : ''}`} {...props}>
    {children}
  </div>
);

InfoBlock.Item = ({ children, className = '', ...props }: IInfoBlockItemProps) => (
  <div className={`np-info-block__item ${className}`} {...props}>
    {children}
  </div>
);

InfoBlock.Title = ({ children, icon, className = '', ...props }: IInfoBlockTitleProps) => (
  <div className={`np-info-block__title ${className}`} {...props}>
    {icon}
    <span>{children}</span>
  </div>
);

InfoBlock.Value = ({ children, className = '', ...props }: IInfoBlockValueProps) => (
  <div className={`np-info-block__value ${className}`} {...props}>
    {children}
  </div>
);

export default InfoBlock;
